import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  useEffect(() => {
    // Preconnect + DNS prefetch to Shopify cart domain for instant CTA navigation
    const links = [{
      rel: 'preconnect',
      href: 'https://learn.alexaaanarvaez.in'
    }, {
      rel: 'dns-prefetch',
      href: 'https://learn.alexaaanarvaez.in'
    }, {
      rel: 'prefetch',
      href: 'https://learn.alexaaanarvaez.in/cart/43580187443265:1'
    }];
    links.forEach(({
      rel,
      href
    }) => {
      const link = document.createElement('link');
      link.rel = rel;
      link.href = href;
      document.head.appendChild(link);
    });
  }, []);
  return <>
      <MetaPixel data-id="element-0" />
      <LandingPage data-id="element-1" />
    </>;
}